import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as KeyboardIcon } from '@pkg/assets/icons/v2/keyboard.svg';
import { CircleButton } from '@pkg/components';

import './InputStateFocusButton.scss';

const InputStateFocusButton = () => {
    const { t } = useTranslation(['yat_picker']);

    const setInputBlur = () => {
        document.getElementById('pickerFormInput')?.focus();
    };

    return (
        <CircleButton
            classes="input-state-focus-button"
            onClick={setInputBlur}
            ariaLabel={t('search_for_emojis')}
            size="large"
        >
            <KeyboardIcon className="input-state-focus-button__icon" />
        </CircleButton>
    );
};

export default InputStateFocusButton;
